export default "{\n    \"placeholder\": \"Describa su tarea\"\n}"